import pre from './pre.js';
import one from './one.js';
import two from './two.js';
import three from './three.js';

export default [
  ...pre,
  ...one,
  ...two,
  ...three,
  'END',
];
